import React, {  useContext } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { GlobalContext } from "../../handlers/GlobalContext";
import { Cookies, getCookieConsentValue } from "react-cookie-consent";

class Login extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            reset: false
        };
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetPassword = this.resetPassword.bind(this);
        this.translate = this.translate.bind(this);
        this.resetSelection = props.reset;
        this.setSelection = props.set;
        this.resetToken = props.token || '';
        this.allowReset = !props.token;
    }


    handleSubmit( values, actions ){
        if(!!this.context[0].error) this.context[0].error = undefined;
        let dispatch = this.context[1];

        if(!getCookieConsentValue()){
            actions.setFieldError('message', this.translate('cookie-consent-not-accepted','To continue using the application, you need to consent to the use of functional cookies at the bottom of the page.'));
            actions.setSubmitting(false);
            return;
        }

        if(!!this.state.reset){
            dispatch({ type: 'RESET_PASSWORD', payload: { UserName: values.username, Email: values.email } })
                .then(() => {
                    let authErrorMessage = !!this.context[0].error ? this.context[0].error.data : undefined; //.message instead of .data
                    if(!!authErrorMessage) {
                        actions.setFieldError('message', this.translate(authErrorMessage));
                        actions.setSubmitting(false);
                        return;
                    }

                    if(!!this.context[0].message) {
                        alert(this.translate(this.context[0].message));
                    }

                    actions.setSubmitting(false);
                    this.resetSelection(true);
                });
        } else {
            dispatch({ type: 'SET_AUTH', payload: { UserName: values.username, Password: values.password } })
                .then(() => {
                    let authErrorMessage = !!this.context[0].authError ? this.context[0].authError.data : undefined; //.message instead of .data
                    if(!!authErrorMessage) {
                        actions.setFieldError('message', this.translate(authErrorMessage));
                        !!this.allowReset && actions.setFieldValue('password', '', false);
                        actions.setSubmitting(false);
                        return;
                    }

                    actions.setSubmitting(false);
                    //this.setState({redirect: "/"});
                    this.resetSelection(true);
                });
        }
    }

    resetPassword(){
        !!this.allowReset && this.setState({reset: !this.state.reset});
    }

    translate = (term, alt) => {
        return this.context[0].locale.translation[term] || alt || term;
    }

    render(){
        const { reset } = this.state;
        return(
            <div className="login-wrap text-center col">
                <h3>{ !!reset ? this.translate("login-title-resetPassword", "Reset password") : this.translate("login-title-login", "Login") }</h3>

                <Formik
                    initialValues={{ username: '', password: this.resetToken, email: '', message: '' }}
                    validate={values => {
                        const errors = {};
                        if (!values.username) {
                            errors.username = this.translate('login-error-usernameRequired','Username required!');
                        }
                        if (!values.password && !reset) {
                            errors.password = this.translate('login-error-passwordRequired','Password cannot be empty!');
                        }
                        if (!values.email && !!reset) {
                            errors.email = this.translate('login-error-emailRequired','Email cannot be empty!');
                        }
                        // if (!!values.message){
                        //     errors.message = values.message;
                        // }
                        // else if (
                        //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                        // ) {
                        //     errors.email = 'Invalid email address';
                        // }
                        return errors;
                    }}
                    onSubmit= { this.handleSubmit }
                >
                    {({ isSubmitting }) => (
                        <Form className="login-form">
                            <ErrorMessage name="message" component="div" className="error-field" />
                            {/*<Field type="email" name="email" />*/}
                            {/*<ErrorMessage name="email" component="div" />*/}
                            <Field type="text" name="username" className="formField" placeholder={this.translate("login-placeholder-username","Username")} />
                            <ErrorMessage name="username" component="div" className="error-field" />

                            { !!reset ? <Field type="text" name="email" placeholder={this.translate("login-placeholder-email","Email")} /> : null}
                            { !!reset ? <ErrorMessage name="email" component="div" className="error-field" /> : null }
                            { !reset ? <Field type="password" name="password" placeholder={this.translate("login-placeholder-password","Password")} disabled={!this.allowReset} /> : null }
                            { !reset ? <ErrorMessage name="password" component="div" className="error-field" /> : null }

                            <button type="submit" disabled={isSubmitting}>
                                {this.translate("login-button-submit","Submit")}
                            </button>
                            <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.resetSelection(true)} }>
                                {this.translate("login-button-back","Back")}
                            </button>
                            <br/>
                            { !!this.allowReset ? <button type="button" className={"secondary"} disabled={isSubmitting} onClick={ () => {this.resetPassword()} }>
                                { (!!reset ? this.translate("login-button-backToLogin","Back to Login") : this.translate("login-button-resetPassword","Reset password")) }
                            </button> : null }
                            <br/>
                            <button type="button" className={"secondary"} disabled={isSubmitting} onClick={() => {this.setSelection(3)} }>
                                {this.translate("home-button-verify","Verify")}
                            </button>
                        </Form>
                    )}
                </Formik>

            </div>
        );
    }
}

Login.contextType = GlobalContext;
export default Login;